
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.826 21.633l2.807-2.807c.49-.49.49-1.275 0-1.765L16.572 12l5.06-5.061c.49-.49.49-1.276 0-1.765l-2.806-2.807a1.244 1.244 0 00-1.765 0L12 7.428l-5.061-5.06a1.245 1.245 0 00-1.765 0L2.367 5.173c-.49.49-.49 1.275 0 1.765L7.428 12l-5.06 5.061c-.49.49-.49 1.276 0 1.765l2.806 2.807c.49.49 1.275.49 1.765 0L12 16.572l5.061 5.06a1.254 1.254 0 001.765 0z","fill":"currentColor"}})])
          )
        }
      }
    